const $ = window.jQuery;

Ok.IncognitoInline = {
	init() {
		this.listen();
	},

	listen() {
		$("body")
			.on("click tap", ".incognito-plan", (e) => {
				e.preventDefault();
				const planid = $(e.currentTarget)
					.closest(".incognito-plan")
					.attr("data-planid");
				this.purchase(planid);
			})
			.on("click tap", ".signup-skip-link", (e) => {
				if ($("#incognito_promo").hasClass("incognito--has")) {
					return true;
				}

				e.preventDefault();
				Modal.open("incognito-confirm");
				ClientStats.update("desktop - signup - incognito - sell page - skip - confirm opened");
			})
			.on("click tap", ".incognito-button--okay", (e) => {
				e.preventDefault();
				const target = $(".signup-skip-link").attr("href");
				ClientStats.update({
					stat: "desktop - signup - incognito - sell page - skip - confirmed",
					cb: () => {
						window.location.href = target;
					},
				});
			})
			.on("click tap", ".incognito-button--cancel", (e) => {
				e.preventDefault();
				Modal.close();
				ClientStats.update("desktop - signup - incognito - sell page - skip - confirm canceled");
			});
	},

	purchase(planid) {
		incognito_controller.set_param("planid", planid);
		incognito_controller.open();

		// analytics shit
		const pkg = IncognitoModal.packageInfo[planid];

		OkAnalytics.logUIEvent(
			OkAnalytics.eventNames.purchasesSelectedPlanOnIncognitoUpsell,
			{
				data: {
					"Plan duration in months": pkg.months,
					"Gross proceeds in local currency": pkg.price / 100,
				},
			},
		);

		OkAnalytics.logUIEvent(
			OkAnalytics.eventNames.purchasesSelectedSubscribeOnIncognitoUpsell,
			{
				data: {
					"Plan duration in months": pkg.months,
					"Gross proceeds in local currency": pkg.price / 100,
				},
			},
		);
	},
};



// WEBPACK FOOTER //
// ./src/legacy/incognito/inline.js